import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import './styles.css';

const STATUS_OPTIONS = [
  { value: '', label: 'All Status' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'IN_REVIEW', label: 'In Review' },
  { value: 'REJECTED', label: 'Rejected' },
];

const TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'FULL', label: 'Full' },
  { value: 'PARTIAL', label: 'Partial' },
];

const FilterInventoriesModal = ({ isOpen, onClose, onApply, initialFilters = {} }) =>
{
  const [freeText, setFreeText] = useState(initialFilters.freeText || '');
  const [status, setStatus] = useState(initialFilters.status || '');
  const [type, setType] = useState(initialFilters.type || '');
  const [dateFrom, setDateFrom] = useState(initialFilters.dateFrom ? dayjs(initialFilters.dateFrom) : null);
  const [dateTo, setDateTo] = useState(initialFilters.dateTo ? dayjs(initialFilters.dateTo) : null);

  if (!isOpen) return null;

  const handleClearAll = () =>
  {
    onApply({ freeText: null, status: null, type: null, dateFrom: null, dateTo: null });
    onClose();
  };

  const handleApply = () =>
  {
    onApply({
      freeText: freeText || null,
      status: status || null,
      type: type || null,
      dateFrom: dateFrom ? dateFrom.toISOString() : null,
      dateTo: dateTo ? dateTo.toISOString() : null,
    });
    onClose();
  };

  return (
    <div className="fi-modal-overlay" onClick={onClose}>
      <div className="fi-modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="fi-modal-header">
          <h2 className="fi-modal-title">Filter Inventories</h2>
          <button className="fi-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="fi-modal-body">
          <input
            type="text"
            className="fi-input"
            placeholder="Search Inventories..."
            value={freeText}
            onChange={(e) => setFreeText(e.target.value)}
          />

          <div className="fi-select-wrapper">
            <select
              className="fi-select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <span className="fi-select-arrow"></span>
          </div>

          <div className="fi-select-wrapper">
            <select
              className="fi-select"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              {TYPE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <span className="fi-select-arrow"></span>
          </div>

          <div className="fi-date-section">
            <label className="fi-date-label">Date Range</label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className="fi-date-row">
                <DateTimePicker
                  label="From"
                  value={dateFrom}
                  onChange={(val) => setDateFrom(val)}
                  slotProps={{
                    textField: {
                      size: 'small',
                      className: 'fi-datetimepicker',
                    },
                  }}
                />
                <span className="fi-date-separator">—</span>
                <DateTimePicker
                  label="To"
                  value={dateTo}
                  onChange={(val) => setDateTo(val)}
                  minDateTime={dateFrom || undefined}
                  slotProps={{
                    textField: {
                      size: 'small',
                      className: 'fi-datetimepicker',
                    },
                  }}
                />
              </div>
            </LocalizationProvider>
          </div>
        </div>

        <div className="fi-modal-footer">
          <button className="fi-btn-clear" onClick={handleClearAll}>Clear All</button>
          <button className="fi-btn-apply" onClick={handleApply}>Apply</button>
        </div>

      </div>
    </div>
  );
};

export default FilterInventoriesModal;
